<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading" class="py-10 py-md-13 py-lg-16">
        <div v-if="item.title">
          <TitleWidget class="text-center">
            {{ item.title }}
          </TitleWidget>

          <div
            v-if="item.text"
            class="grey--text text--darken-1 text-body-1 text-center mt-4"
          >
            {{ item.text }}
          </div>

          <v-sheet
            v-if="item.link"
            class="black mx-auto mt-6 video"
            color="transparent"
            max-width="800px"
          >
            <iframe
              :src="
                'https://www.youtube.com/embed/' + getYoutubeCode(item.link)
              "
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </v-sheet>

          <BusinessSection />

          <MaterialsSection />
        </div>

        <v-alert v-else type="info" width="100%">
          Nenhum conteúdo adicionado até o momento.
        </v-alert>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import BusinessSection from "../components/sections/BusinessSection.vue";
import MaterialsSection from "../components/sections/MaterialsSection.vue";
import { getYoutubeCode } from "../utils/getYoutubeCode";

const _config = {
  mod: "recycleAbout",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    getYoutubeCode,
  },
  components: {
    LoadingWidget,
    TitleWidget,
    BusinessSection,
    MaterialsSection,
  },
};
</script>
